export enum DEVICE_ACTION_TYPES {
    GET_DEVICE_START = 'device/GET_DEVICE_START',
    GET_DEVICE_SUCCESS = 'device/GET_DEVICE_SUCCESS',
    GET_DEVICE_FAILED = 'device/GET_DEVICE_FAILED',
    GET_DEVICE_PARAMS_CHART_DATA_START = 'device/GET_DEVICE_PARAMS_CHART_DATA_START',
    GET_DEVICE_PARAMS_CHART_DATA_SUCCESS = 'device/GET_DEVICE_PARAMS_CHART_DATA_SUCCESS',
    GET_DEVICE_PARAMS_CHART_DATA_FAILED = 'device/GET_DEVICE_PARAMS_CHART_DATA_FAILED',
    GET_DEVICE_STATUS_START = 'device/GET_DEVICE_STATUS_START',
    GET_DEVICE_STATUS_SUCCESS = 'device/GET_DEVICE_STATUS_SUCCESS',
    GET_DEVICE_STATUS_FAILED = 'device/GET_DEVICE_STATUS_FAILED',
}